import React, { Component } from "react";
import {no_item_found} from "../../resources/string/strings"

class Loading extends Component {
  state = {};
  render() {
    return (
      <div
        style={{ marginTop: 20, fontSize: 13, color: "GrayText" }}
        role="status"
      >
        {no_item_found}
      </div>
    );
  }
}

export default Loading;
